import { render, staticRenderFns } from "./cAdminSettings.vue?vue&type=template&id=22f3cc24&scoped=true"
import script from "./cAdminSettings.vue?vue&type=script&lang=js"
export * from "./cAdminSettings.vue?vue&type=script&lang=js"
import style0 from "./cAdminSettings.vue?vue&type=style&index=0&id=22f3cc24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3cc24",
  null
  
)

export default component.exports